import { IFeedConfiguration } from 'feed';
import React, { useState } from 'react';
import ParamCss from '~/components/generic/StepSelectorAndDesign/Sidebar/FeedEditorAppearance/ParamCss';
import HandCategoryActiveButtonParams from '~/components/generic/StepSelectorAndDesign/Sidebar/FeedEditorAppearance/Tools/Categories/CategoryActiveButton/HandCategoryActiveButtonParams';
import { currentCategoryActiveButtonTextCssParam } from '~/components/generic/StepSelectorAndDesign/Sidebar/FeedEditorAppearance/Tools/Categories/CategoryActiveButton/currentCategoryActiveButtonTextCssParam';
import { cssSwitchButtons } from '~/components/generic/StepSelectorAndDesign/Sidebar/FeedEditorAppearance/constants';
import FormItem from '~/components/ui/FormItem';
import SwitchButton from '~/components/ui/SwitchButton';

interface ICategoryButtonProps {
  configuration: IFeedConfiguration;
  onChange: (
    configuration: IFeedConfiguration,
    isDesignUpdate?: boolean
  ) => void;
}

const CategoryActiveButton: React.FC<ICategoryButtonProps> = ({ configuration, onChange }) => {
  const [switchButtonState, setSwitchButtonState] = useState<string>(
    configuration.css?.categoryActiveButton ? 'CSS' : 'HAND'
  );
  const onChangeCssParam = (value: string) => {
    const css = configuration.css ?? {};
    css.categoryActiveButton = value;
    onChange({ ...configuration, css });
  };

  return (
    <>
      <section className="feed-editor-appearance__section">
        <FormItem
          title="Настройка выбранной категории"
          overlayClassName="feed-editor-appearance__tooltip"
          className="feed-editor-appearance__font"
        >
          <SwitchButton
            buttons={cssSwitchButtons}
            activeKey={switchButtonState}
            onClick={setSwitchButtonState}
          />
        </FormItem>
        {switchButtonState === 'CSS' && (
          <ParamCss
            title={'Выбранная категория'}
            onChangeCssParam={onChangeCssParam}
            value={
              configuration.css?.categoryActiveButton ??
              currentCategoryActiveButtonTextCssParam(configuration)
            }
          />
        )}
      </section>
      {switchButtonState === 'HAND' && (
        <HandCategoryActiveButtonParams
          isActive={switchButtonState === 'HAND'}
          configuration={configuration}
          onChange={onChange}
          onChangeCssParam={onChangeCssParam}
        />
      )}
    </>
  );
};

export default CategoryActiveButton;
